var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6621 13.9949V12.6621C12.6621 11.9551 12.3812 11.277 11.8813 10.7771C11.3814 10.2772 10.7033 9.99634 9.99633 9.99634H5.99775C5.29076 9.99634 4.61272 10.2772 4.1128 10.7771C3.61288 11.277 3.33203 11.9551 3.33203 12.6621V13.9949",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99677 7.33071C9.46901 7.33071 10.6625 6.13722 10.6625 4.66499C10.6625 3.19275 9.46901 1.99927 7.99677 1.99927C6.52454 1.99927 5.33105 3.19275 5.33105 4.66499C5.33105 6.13722 6.52454 7.33071 7.99677 7.33071Z",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers3);
export default __webpack_public_path__ + "static/media/Users3.ea26c87a3376cf7c941b54f317f4b7fe.svg";
export { ForwardRef as ReactComponent };